import { FunctionComponent, PropsWithChildren } from 'react';

import { AvatarProps, default as MuiAvatar } from '@mui/material/Avatar';

const Avatar: FunctionComponent<AvatarProps> = (
  props: PropsWithChildren<AvatarProps>
) => {
  return <MuiAvatar {...props}>{props.children}</MuiAvatar>;
};

export default Avatar;
